import { RM01 } from "./RM01";

export const RegionCoverageReport = {
  sections: [RM01],
};
